var map = {
	"./af.yml": "1831",
	"./bd.yml": "7e03",
	"./bf.yml": "46c7",
	"./bg.yml": "2aa5",
	"./bn.yml": "8aa7",
	"./bp.yml": "52cb",
	"./cc.yml": "c8bf",
	"./cd.yml": "09e5",
	"./cs.yml": "aa95",
	"./ct.yml": "e2d6",
	"./de.yml": "363b",
	"./el.yml": "a6fa",
	"./en.yml": "eb57",
	"./es.yml": "4020",
	"./fc.yml": "1043",
	"./fr.yml": "8755",
	"./gu.yml": "0448",
	"./hg.yml": "d645",
	"./hi.yml": "eeb9",
	"./hu.yml": "2020",
	"./it.yml": "2055",
	"./ja.yml": "d602",
	"./ka.yml": "b867",
	"./kn.yml": "ed81",
	"./ko.yml": "096c",
	"./lp.yml": "8889",
	"./ml.yml": "a3f7",
	"./mr.yml": "1801",
	"./ms.yml": "0abe",
	"./nl.yml": "31f5",
	"./ns.yml": "b6c8",
	"./pl.yml": "958c",
	"./pt.yml": "67c3",
	"./ro.yml": "cc8f",
	"./ru.yml": "01aa",
	"./sp.yml": "c42c",
	"./sr.yml": "5d09",
	"./st.yml": "e365",
	"./ta.yml": "8535",
	"./te.yml": "9f8a",
	"./th.yml": "e0ee",
	"./tl.yml": "a790",
	"./tr.yml": "a0db",
	"./vi.yml": "2d96",
	"./xh.yml": "c64d",
	"./zh.yml": "1cbb",
	"./zu.yml": "afa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";